import React, { useMemo } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
  Badge,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import {
  Switch,
  Route,
  useRouteMatch,
  Redirect,
  useHistory,
} from "react-router-dom";
import Select from "react-select";
import clsx from "clsx";

import MainLayout from "../../layouts/MainLayout";
import { PageHeader } from "../../components/PageHeader";
import { useFetchFeaturedPublicTemplate } from "../../api/hooks/public-templates";
import ImagePlaceholder from "../../images/templates/placeholder.jpg";
import { TemplateCatalog } from "./TemplateCatalog";
import { PlaylistCatalog } from "./PlaylistCatalog";
import { MyTemplatesList } from "./MyTemplatesList";
import { LawyersCatalog } from "./LawyersCatalog";
const trendingTopics = ["RH", "Laboral"];

function ContractList() {
  const { t } = useTranslation();
  const { path, url } = useRouteMatch();
  const { isSuccess, data = {} } = useFetchFeaturedPublicTemplate();

  const tabs = useMemo(() => {
    return [
      {
        id: 1,
        path: `${url}/catalog`,
        label: t("Catalogue"),
      },
      {
        id: 2,
        path: `${url}/own`,
        label: t("myTemplates"),
      },
      {
        id: 3,
        path: `${url}/playlists`,
        label: t("Playlists"),
      },
      {
        id: 4,
        path: `${url}/lawyers`,
        label: t("templates.list.0"),
      },
    ];
  }, [t, url]);

  let testString = "Acuerdo Simplificado De Acciones Futuras (Safe)";
  return (
    <MainLayout className="">
      <PageHeader className="bg-white pb-0 pt-4">
        <Row className="justify-content-between w-100">
          <Col md={9}>
            <PageHeader.Title>{t("template", { count: 2 })}</PageHeader.Title>
            <div style={{ maxWidth: "560px" }}>
              {t("template-catalog:subtitle")}
            </div>
          </Col>
          {/* <Col md={3}>
            {isSuccess && (
              <MiniTemplateItem
                id={data?._id}
                image={data?.image}
                //  name={data?.name}
                name={
                  data?.name
                    ? data?.name?.length <= 30
                      ? data?.name
                      : `${data?.name?.slice(0, 30)}...`
                    : ""
                }
                category={data?.categories?.[0]?.name || "Nueva Plantilla"}
              />
            )}
          </Col> */}
        </Row>
        <PageHeader.Tabs tabs={tabs} />
      </PageHeader>
      <Switch>
        <Route path={`${path}/catalog`}>
          <TemplateCatalog />
        </Route>
        <Route path={`${path}/own`}>
          <MyTemplatesList />
        </Route>
        <Route path={`${path}/playlists`}>
          <PlaylistCatalog />
        </Route>
        <Route path={`${path}/lawyers`}>
          <LawyersCatalog />
        </Route>
        <Redirect from={path} to={`${path}/catalog`} />
      </Switch>
    </MainLayout>
  );
}

export default ContractList;

export function MiniTemplateItem({
  className,
  id,
  image = ImagePlaceholder,
  name,
  subtitle,
  category,
}) {
  const history = useHistory();

  const goToPublicTemplate = () => {
    history.push(`/public-templates/${id}/edit`);
  };

  return (
    <div
      className={clsx("d-flex w-100 cursor-pointer", className)}
      onClick={goToPublicTemplate}
    >
      <div className="d-flex align-items-center">
        {/* <div className="rounded-lg"  style={{
                    backgroundImage: `url(${image})`,
                    objectFit: 'cover',
                    backgroundPosition: 'center',
                    width: 90,
                    height: 90
                }}></div> */}
        <img
          className="rounded-lg"
          src={image || ImagePlaceholder}
          width="96px"
          height="96px"
          alt=""
        />
      </div>
      <div className="px-3 d-flex flex-column">
        {subtitle && <div className="text-muted">{subtitle}</div>}
        <h4 className="font-weight-bold font-size-20">{name}</h4>
        <div className="as-link text-accent text-capitalize font-size-18">
          {category}
        </div>
      </div>
    </div>
  );
}
